import { DiscountListItemDto } from "app/shared/model/DiscountListItemDto";
import { PageLoadedData, Action, ActionType } from "app/pages/DiscountsList/actionTypes";
import { DiscountType } from "app/shared/model/DiscountType";

export function pageLoaded(discounts: DiscountListItemDto[], data: PageLoadedData) : Action { 
    return {
        type: ActionType.PageLoaded,
        discounts: discounts,
        data: data
    };
}

export function changeSearchTerm(searchTerm: string) : Action {
    return {
        type: ActionType.ChangeSearchTerm,
        searchTerm: searchTerm
    }
}